import { t } from 'i18next';
import * as yup from 'yup';

import { TreadAgentSkill } from '~hooks/useTreadAgent/models';

export const SKILL_DESCRIPTION_MAX_LENGTH = 300;
export const SKILL_CONTENT_MAX_LENGTH = 8000;
const SKILL_NAME_FORMAT = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const treadAgentSkillSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(t('form_validation_errors.required_simple'))
    .matches(SKILL_NAME_FORMAT, t('tread_agent.skills.name_format_error')),
  description: yup
    .string()
    .trim()
    .required(t('form_validation_errors.required_simple'))
    .max(SKILL_DESCRIPTION_MAX_LENGTH),
  content: yup
    .string()
    .trim()
    .required(t('form_validation_errors.required_simple'))
    .max(SKILL_CONTENT_MAX_LENGTH),
});

export type TreadAgentSkillDto = yup.InferType<typeof treadAgentSkillSchema>;

export const setTreadAgentSkillDefaultValues = (
  skill?: TreadAgentSkill,
): TreadAgentSkillDto => ({
  name: skill?.name ?? '',
  description: skill?.description ?? '',
  content: skill?.content ?? '',
});
